import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToPrice = () => {
    const priceSection = document.getElementById('price-section');
    if (priceSection) {
      priceSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-12 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-18">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-zinc-900 via-[#0a0a0a] to-[#0a0a0a] opacity-80" data-id="element-19" />

      {/* Warm glow effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#d4a574] rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-20" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left space-y-3" data-id="element-22">
          <div className="space-y-1" data-id="element-23">
            <motion.span initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3
          }} className="inline-block text-[#d4a574] tracking-widest text-xs font-medium uppercase" data-id="element-24">
              Guía de Reconexión
            </motion.span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium leading-[1] text-white" data-id="element-25">
              No pidas una conversación. <br data-id="element-26" />
              <span className="italic text-[#d4a574]" data-id="element-27">Abre una puerta.</span>
            </h1>
            <p className="text-lg text-zinc-400 max-w-2xl mx-auto lg:mx-0 font-light leading-[1.2] pt-1" data-id="element-28">
              5 mensajes. 24 horas. Un clima distinto. <br data-id="element-29" />
              Rompe el hielo sin peleas, sin vergüenza y sin "tenemos que
              hablar".
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 justify-center lg:justify-start pt-1" data-id="element-30">
            <Button icon onClick={scrollToPrice} data-id="element-31">
              Quiero los 5 Mensajes
            </Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto lg:mx-0" data-id="element-32">
          <div className="relative z-10 rounded-lg shadow-2xl shadow-[#d4a574]/10" data-id="element-33">
            <img src="https://cdn.magicpatterns.com/uploads/ifq25uAcye6gyL9d6YcvrT/mockup_2_-_1x1.png" alt="Conexión Instantánea en iPad" className="w-full max-w-md lg:max-w-full h-auto rounded-lg" data-id="element-34" />
          </div>
          {/* Decorative ring */}
          <div className="absolute inset-0 border border-[#d4a574]/20 rounded-lg transform translate-x-4 translate-y-4 -z-10" data-id="element-35" />
        </motion.div>
      </div>
    </section>;
}